import React from "react";
import LogoDark from "../../assets/img/logo/logo-dark.svg"
import LogoLight from "../../assets/img/logo/logo-light.svg"

export default function HeaderComponent() {
  return (
    <>
      {/* <div className="loading">
        <div className="wrapper h-100">
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="loading-content">
              <div className="logo logo-primary">
                <img className="animated zoomin" src="assets/img/logo/logo-dark.svg" alt="Logo"/>
              </div>
            </div>
          </div>
        </div>
      </div>  */}

      <header id="header" className="site-header">
        <div className="wrapper">
          <div className="header-content d-flex justify-content-between">
            <div className="header-left align-self-center">
              <div className="header-logo">
                <a className="logo logo-primary adv-dark transform-scale-h" title="Logo" href="/">
                  <img src={LogoDark} alt="Logo"/>
                </a>

                <a className="logo logo-secondary adv-light transform-scale-h" title="Logo" href="/">
                  <img src={LogoLight} alt="Logo"/>
                </a>
              </div>
            </div>

            <div className="header-right d-flex justify-content-end">
              <div className="d-flex align-items-center">
                <div className="menu">
                  <nav className="menu-primary">
                    <ul className="nav">
                      <li className="nav-item">
                        <a title="Services" href="#services">Services</a>
                      </li>

                      <li className="nav-item">
                        <a title="About Us" href="#about-us">About Us</a>
                      </li>

                      <li className="nav-item">
                        <a title="Teams" href="#team-members">Team</a>
                      </li>

                      {/* <li className="nav-item">
                        <a title="Pricing" href="#price-plans">Pricing</a>
                      </li> */}
{/* 
                      <li className="nav-item">
                        <a title="Testimonials" href="#testimonials">Testimonials</a>
                      </li> */}

                      {/* <li className="nav-item">
                        <a title="News" href="#news">News</a>
                      </li> */}

                      <li className="nav-item">
                        <a title="Contacts" href="#contacts">Contacts</a>
                      </li>
                    </ul>
                  </nav>
                </div>

                {/* <div className="search-toggle adv-light">
                  <button type="button" className="btn btn-lg btn-outline-secondary btn-round p-0 min-w-auto" data-toggle="modal" data-target="#search-modal"><i className="fas fa-search"></i></button>
                </div> */}

                <div className="menu-toggle adv-light mr-0">
                  <button type="button" className="btn btn-lg btn-outline-secondary btn-round p-0 min-w-auto" data-toggle="modal" data-target="#menu-modal"><i className="fas fa-bars"></i></button>
                </div>

                <div className="menu-toggle adv-dark">
                  <button type="button" className="btn btn-lg btn-secondary btn-hover-main-secondary btn-round p-0 min-w-auto" data-toggle="modal" data-target="#menu-modal"><i className="fas fa-bars"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header> 
    </>
  );
}
